export default __webpack_public_path__ + "static/media/navigation.7c8e46e9.svg";